export const iconFontAwesomeSocialShare = (
	<i className="fa-solid fa-share"></i>
);
